import { AuthFormTranslationsCs } from 'components/Forms/AuthForm/translations/cs';
import { SectionHeroTranslationsCs } from 'components/SectionHero/translations/cs';
import { SectionAboutUsTranslationsCs } from 'components/SectionAboutUs/translations/cs';
import { SectionOurMissionTranslationsCs } from 'components/SectionOurMission/translations/cs';
import { FormRegistrationEmailTranslationsCs } from 'components/Forms/FormRegistrationEmail/translations/cs';
import { FormRegistrationPhoneNumberTranslationsCs } from 'components/Forms/FormRegistrationPhoneNumber/translations/cs';
import { ModalChangeEmailTranslationsCs } from 'components/Modals/ModalChangeEmail/translations/cs';
import { ModalRegisterTranslationsCs } from 'components/Modals/ModalRegister/translations/cs';
import { ModalAddAvatarTranslationsCs } from 'components/Modals/ModalAddAvatar/translations/cs';
import { ModalChangePasswordTranslationsCs } from 'components/Modals/ModalChangePassword/translations/cs';
import { ModalChangePhoneNumberTranslationsCs } from 'components/Modals/ModalChangePhoneNumber/translations/cs';
import { ModalChangePhotoTranslationsCs } from 'components/Modals/ModalChangePhoto/translations/cs';
import { ModalLogOutTranslationsCs } from 'components/Modals/ModalLogOut/translations/cs';
import { ModalChangeNicknameTranslationsCs } from 'components/Modals/ModalChangeNickname/translations/cs';
import { ModalResetPasswordTranslationsCs } from 'components/Modals/ModalResetPassword/translations/cs';

export const ComponentTranslationsCs = {
  // forms
  formRegistrationEmail: FormRegistrationEmailTranslationsCs,
  formRegistrationPhoneNumber: FormRegistrationPhoneNumberTranslationsCs,
  authForm: AuthFormTranslationsCs,

  // modals
  modalResetPassword: ModalResetPasswordTranslationsCs,
  modalChangeNickname: ModalChangeNicknameTranslationsCs,
  modalLogOut: ModalLogOutTranslationsCs,
  modalChangePhoto: ModalChangePhotoTranslationsCs,
  modalChangePhoneNumber: ModalChangePhoneNumberTranslationsCs,
  modalChangeEmail: ModalChangeEmailTranslationsCs,
  modalChangePassword: ModalChangePasswordTranslationsCs,
  modalAddAvatar: ModalAddAvatarTranslationsCs,
  modalRegister: ModalRegisterTranslationsCs,


  sectionHero: SectionHeroTranslationsCs,
  sectionAboutUs: SectionAboutUsTranslationsCs,
  sectionOurMission: SectionOurMissionTranslationsCs,

};
